import { string } from 'yup';
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

// Optional field: format is only checked when a value is present, matching
// the account phone number's non-mandatory nature.
export const accountPhoneScheme = () =>
  string().test('valid-phone', 'Invalid Format', (value) => {
    if (!value) {
      return true;
    }

    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
    } catch {
      return false;
    }
  });
